<template>
  <div class="card mb-2 box-shadow" id="session-info">
    <div
      class="card-header brighter d-flex justify-content-between text"
      v-text="Title"
    >
      <!-- <a href="javascript:void(0)" class>
        <font-awesome-icon :icon="['fas', 'external-link-alt']" />
      </a>-->
    </div>
    <div
      class="card-body text-center d-flex align-items-center flex-wrap"
      style="height:109px"
      v-if="state.sessions.session.type == 'open'"
    >
      <a href="javascript:void(0)" class="w-100" @click="checkSessionStatus">
        <font-awesome-icon :icon="['fas', 'plus']" />&nbsp; Open Session
      </a>
    </div>

    <div class="card-body" v-if="state.sessions.session.type == 'close'">
      <div>
        <small>Opened at</small>
        <p>{{ state.sessions.session.time | moment("DD MMMM YYYY h:mm A") }}</p>
      </div>
      <div>
        <small>Opened by</small>
        <p v-text="state.sessions.session.username"></p>
      </div>
    </div>
    <session-modal-box
      :open="openBox"
      @close-session="sessionBoxClose"
    ></session-modal-box>
    <message-box
      :open="error"
      @close-message="flushError"
      :message="errorMsg"
    ></message-box>
  </div>
</template>

<script>
import SessionModalBox from "../components/SessionModalBox";
import { mapState } from "vuex";
import MessageBox from "../components/MessageBox";
import * as msg from "../message";
export default {
  name: "session-information",
  components: {
    SessionModalBox,
    MessageBox,
  },
  data() {
    return {
      Title: "Session Information",
      openBox: false,
      error: false,
      errorMsg: {
        btnText: "",
        text: "",
        type: "",
      },
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
  },
  methods: {
    sessionBoxClose(data) {
      this.openBox = data;
    },
    checkSessionStatus() {
      if (
        this.state.system.settings.settlement
          .closing_previous_session_compulsory.status == 1 &&
        this.state.system.settings.settlement.open_sesssion_compulsory.status ==
          1
      ) {
        this.openBox = true;
      } else {
        this.error = true;
        this.errorMsg.text = msg.SESSION_MNGMT_DISABLED;
        this.errorMsg.btnText = "Close";
      }
    },
    flushError(val) {
      this.error = val;
      this.errorMsg = {
        btnText: "",
        text: "",
        type: "",
      };
    },
  },
};
</script>
